import { useEffect } from "react";
import { useState, useContext, createContext } from "react";
import { APP_USER_SESSION } from "../constant/AppConstants";
import { StorageUtils } from "../utils";

const userContext = createContext(null);

export const UserProvider = ({ page, children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    if (!user) {
      setUser(StorageUtils.getParsedValue(APP_USER_SESSION).role);
    }
  }, [user]);

  return <userContext.Provider value={user}>{children}</userContext.Provider>;
};

export const useUserContext = () => useContext(userContext);
